var exports = {
  "k": "TextInput__Ugrnkz",
};

module.exports = exports;
